import styled from 'styled-components';

const TopGroupStyled = styled.div`
  height: 160px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  .card-content {
    width: 50%;
    padding: 24px;
    display: flex;
    .top {
      width: 100%;
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      .top_bold {
        width: 64px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #212121;
        line-height: 22px;
        white-space: nowrap;
        display: flex;
        overflow-wrap: break-word;
        padding-right: 505px;
      }
      .top_date {
        width: 163px;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #939393;
        line-height: 17px;
        white-space: nowrap;
        display: flex;
        overflow-wrap: break-word;
      }
    }
  }
`;

export default TopGroupStyled;
